import _ from 'lodash'
import Nav from 'scoreboard/components/nav'
import Dashboard from './dashboard'
import NewTab from 'scoreboard/components/new-tab'
import permissions from 'scoreboard/components/permissions'

var DashboardsNav = Nav.extend({
	section: 'dashboards',
	Model: Dashboard,

	events: _.extend({}, Nav.prototype.events, NewTab.events),

	isEditable: function(orgId) {
		return permissions.dashboards(orgId)
	},

	// When changing the transient after the dashboard edit view has been updated,
	// we don't need to deal with updating the position of the node since there
	// are no node type hierarchies to deal with #31432
	changeTransient: function(attributes) {
		this._updateTransientAttributes(attributes)
	}

})

_.extend(DashboardsNav.prototype, _.omit(NewTab, 'events'))

export default DashboardsNav

DashboardsNav.__filename__ = 'dashboards/dashboards-nav.js'
